import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Tab from './Tab';
import './Tabs.scss';

class TabManager extends Component {
    static propTypes = {
        children: PropTypes.instanceOf(Array).isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            // activeTab: props.children[0].props.label,
            // child: props.children.map((child) => child.props.label === props.children[0].props.label ? child.props.children : undefined),
            activeTab: 'null',
            child: undefined,
        };
    }

    onClickTabItem = (tab) => {
        const childObj = this.props.children.map((child) => child.props.label === tab ? child.props.children : undefined);
        this.setState(() => ({
            activeTab: tab,
            child: childObj,
        }));
        setTimeout(() => {
            window.scrollTo(0, 5000)
        }, 20, {behavior: 'smooth'}); // On graph selection, scroll to bottom
    };

    render() {
        const {
            onClickTabItem,
            props: {
                children,
            },
            state: {
                activeTab,
                child,
            }
        } = this;

        return (
            <div className="tabs">
                <ul className="tabs primary-nav">
                    {children.map((child) => {
                        const {label} = child.props;

                        return (
                            <Tab
                                activeTab={activeTab}
                                key={label}
                                label={label}
                                onClick={onClickTabItem}
                            />
                        );
                    })}
                </ul>
                <div className="tab-content">
                    {child}
                </div>
            </div>
        );
    }
}

export default TabManager;
